export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_37-12914ef922fd7afd48e3abe067d24674.jpg";